import React from "react";
import ViewReverse from "../../components/ViewReverse";
import Text from "../../components/Text";
import ViewItems from "../../components/ViewItems";
import overviewFunctional from "./index.function";
import { fontSizes } from "../../constants/constants";
import LoaderModal from "../../components/LoaderModal";
import Button from "../../components/Button";
import icons from "../../constants/icons";
import { CardView } from "./components";
import SarSymbol from "../../components/SarSymbol";
import { clientSuspendedToast } from "../../utils/functions";

const Overview = () => {
  const {
    clientDetails,
    getContentKey,
    clientLoading,
    TextWeight,
    direction,
    navigate,
    user,
    isSecure,
    setIsSecure,
    isArabic,
  } = overviewFunctional();

  const currency = clientDetails?.cashAccountList?.[0]?.accountInformation?.currency

  return (
    <div>
      <ViewReverse className="justify-between" >
        <Text
          text={getContentKey('cash_overview')}
          size={fontSizes.h24}
          weight={TextWeight.bold}
          color='text-black'
        />
        <Button
          // isDisabled={user?.isClientSuspended}
          text={getContentKey("topup")}
          rightIcon={icons.top_up}
          className={"w-40"}
          onClick={() => user?.isClientSuspended ? clientSuspendedToast(isArabic) : navigate("/transfers/topup")}
        />
      </ViewReverse>

      <div
        dir={direction}
        className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6 justify-between"}
      >
        <CardView
          title={getContentKey("total")}
          amount={clientDetails?.cashAccountList?.[0]?.total}
          icon={icons.eye_icon}
          secure={true}
          isSecure={isSecure}
          setIsSecure={setIsSecure}
        />
        <CardView
          title={getContentKey("available_cash")}
          amount={clientDetails?.cashAccountList?.[0]?.availableCash}
          icon={icons.cash_icon}
          secure={true}
          isSecure={isSecure}
        />
        <CardView
          title={getContentKey("reserved_cash")}
          amount={clientDetails?.cashAccountList?.[0]?.blockedCash}
          icon={icons.reserved_icon}
          secure={true}
          isSecure={isSecure}
        />
      </div>

      <ViewItems
        className={
          "border mt-6 border-grey px-5 pt-6 pb-4 shadow-light rounded-xl w-full"
        }
      >
        <Text
          text={getContentKey("account_information")}
          size={fontSizes.h16}
          weight={TextWeight.semiBold}
        />

        <ViewReverse
          className={"w-full mt-2 border-b border-b-grey py-3 justify-between"}
        >
          <Text text={getContentKey("name_of_bank")} size={fontSizes.h14} />
          <Text
            text={clientDetails?.cashAccountList?.[0]?.accountInformation?.bank}
            size={fontSizes.h14}
            weight={TextWeight.semiBold}
            color="text-primary"
          />
        </ViewReverse>
        <ViewReverse
          className={"w-full border-b border-b-grey py-3 justify-between"}
        >
          <Text text={getContentKey("currency")} size={fontSizes.h14} />
          {
            currency === 'SAR' ?
              <SarSymbol className={'text-primary'} />
              :
              <Text
                text={currency}
                size={fontSizes.h14}
                weight={TextWeight.semiBold}
                color="text-primary"
              />
          }
        </ViewReverse>
        <ViewReverse className={"w-full pt-3 justify-between"}>
          <Text text={getContentKey("iban")} size={fontSizes.h14} />
          <Text
            text={
              clientDetails?.cashAccountList?.[0]?.accountInformation
                ?.cashAccount
            }
            size={fontSizes.h14}
            weight={TextWeight.semiBold}
            color="text-primary"
          />
        </ViewReverse>
      </ViewItems>

      <LoaderModal open={clientLoading} />
    </div>
  );
};

export default Overview;
